import {
  HirerTeamMemberJobAccessForm,
  type OnNotifyChangeEventData,
} from '@seek/hirer-team-member-job-access';
import { useTranslations } from '@vocab/react';
import { Heading, Stack, Strong, Box } from 'braid-design-system';
import React from 'react';

import translations from './.vocab';
interface Props {
  onNotifyChange?: (eventData: OnNotifyChangeEventData) => void;
}
export const StepTeamAccessPanel = ({ onNotifyChange }: Props): JSX.Element => {
  const { t } = useTranslations(translations);
  return (
    <Box paddingTop="xsmall">
      <Stack space="xlarge">
        <Heading level="3">
          <Strong>{t('step-team-access-panel-description')}</Strong>
        </Heading>
        <Box paddingBottom="xlarge">
          <HirerTeamMemberJobAccessForm
            id="team-members"
            onNotifyChange={onNotifyChange}
          />
        </Box>
      </Stack>
    </Box>
  );
};
